'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notify = undefined;

var _util = require('@ux/util');

var _botUtils = require('../bot-utils');

var lpLogPrefix = 'lp ';

/**
 * Posts the respective live chat events to chatbots-api logs via postToLog method.
 *
 * @param  {String} logText the text to post to chatbots-api logs
 * @param  {String} sessionId the dialogflow sessionId
 * @param  {String} logUrl the base url for posting to logs
 */
var postToLog = function postToLog(logText, sessionId, logUrl) {
  var options = {
    headers: { 'Content-Type': 'application/json' }
  };
  var data = JSON.stringify({
    sessionId: sessionId,
    log: logText
  });
  _util.request.post(logUrl + '/postToLog', data, options, function (err) {
    if (err) {
      throw new Error(err);
    }
  });
};

/**
 * Called on LivePerson API connection events in order to monitor live chat sessions.
 *
 * @param  {String} evt the name of the LivePerson API event
 * @param  {Object} data the data associated with the event
 * @param  {String} sessionId the dialogflow sessionId
 * @param  {String} logUrl the base url for posting to logs
 */
var notify = exports.notify = function notify(evt, data, sessionId, logUrl) {
  if (!evt || !data || !sessionId || !logUrl) {
    return;
  }

  var logEntry = '';

  if (evt === 'onState' || evt === 'onStart') {
    logEntry = evt + ': ' + data.state + ', time: ' + data.time;
  } else if (evt === 'onRequestChat') {
    if (data.info) {
      logEntry = evt + ': ' + data.info.state + ' ' + data.info.skillName + ' ' + data.info.agentName + ', ' + ('engagementId: ' + data.info.engagementId + ', startTime: ' + data.info.startTime);
    } else {
      logEntry = '' + evt;
    }
  } else if (evt === 'onInfo') {
    logEntry = evt + ': agentName: ' + data.agentName + ', chatInProgress: ' + data.chatInProgress;
  } else if (evt === 'onEngagement') {
    logEntry = evt + ': sessionId: ' + data.sessionId + ', visitorId: ' + data.visitorId + ', ' + ('pageId: ' + data.pageId);
  } else if (evt === 'onLine') {
    if (data.lines && data.lines.length) {
      data.lines.forEach(function (line) {
        var lineText = (0, _botUtils.maskPIIData)(line.text);
        lineText = line.textType === 'html' ? encodeURIComponent(lineText) : lineText;
        logEntry = evt + ': seq: ' + line.sequenceId + ', who: ' + line.source + ', text: ' + lineText + ', ' + ('time: ' + line.time);
      });
    }
  } else if (evt === 'onVisitorDisposed') {
    logEntry = '' + evt;
  } else if (evt === 'endConnection') {
    logEntry = evt + ': ' + data;
  } else if (evt === 'onError') {
    var onErrorData = JSON.stringify({ data: data });
    logEntry = evt + ': ' + onErrorData;
  } else if (evt === 'onErrorOther') {
    logEntry = evt + ': ' + JSON.stringify({ data: data });
  }

  if (logEntry) {
    postToLog(lpLogPrefix + logEntry, sessionId, logUrl);
  }
};